var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "gnb-icon-bg",
    cx: 141.73,
    cy: 141.73,
    r: 141.73,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M112.79,159.76c-9.98,1.22-19.78,1.67-29.76,1.41-27.66-.71-58.74-8.12-71.12-35.23-1.92-4.21-3.14-8.5-4.17-12.84-4.81-20.31,7.77-40.37,27.82-44.92,20.15-4.57,40.22,8.2,44.49,28.69,2.39,11.47-.79,23.46-8.78,32.26l-4.46,4.61,4.86,5.15c9.94,10.54,26.7,17.41,41.12,20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M150.04,174.9c-1.94,9.86-4.54,19.32-7.88,28.74-9.25,26.08-25.92,53.33-55.53,56.7-4.6.52-9.05.35-13.5-.02-20.8-1.72-35.98-19.9-34.09-40.37,1.9-20.57,20.26-35.7,41.06-33.41,11.65,1.28,22.06,8.02,27.95,18.34l3,5.66,6.4-3.02c13.11-6.18,24.82-19.99,32.58-32.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M175.66,144.16c8.79,4.87,16.99,10.26,24.92,16.33,21.98,16.82,42.78,41.06,36.89,70.27-.92,4.54-2.45,8.72-4.16,12.84-8.03,19.27-29.99,28.12-48.89,20.03-18.99-8.13-27.75-30.25-19.17-49.34,4.8-10.69,14.41-18.53,26.04-20.96l6.31-1.11-.91-7.02c-1.86-14.37-11.39-29.76-21.03-41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M154.54,110.08c7.36-6.85,15.02-12.97,23.25-18.63,22.8-15.68,52.3-27.95,78.24-13.3,4.03,2.28,7.53,5.03,10.92,7.94,15.83,13.61,17.44,37.23,3.9,52.69-13.61,15.54-37.36,17.01-52.86,2.94-8.68-7.88-13.15-19.44-11.86-31.26l.9-6.35-6.96-1.31c-14.24-2.69-31.83,1.61-45.53,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M115.61,119.81c-4.24-9.11-7.7-18.3-10.54-27.87-7.87-26.53-10.42-58.37,11.53-78.52,3.41-3.13,7.11-5.61,10.92-7.93,17.83-10.85,40.8-5.09,51.32,12.58,10.57,17.75,4.63,40.79-13.54,51.18-10.17,5.82-22.56,6.5-33.39,1.62l-5.76-2.82-3.4,6.21c-6.96,12.71-8.3,30.77-7.14,45.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.d73574987da656333440060ed6655d15.svg";
export { ForwardRef as ReactComponent };